import { useTranslator } from '@/hooks/useTranslator'
import { classes } from '@lc/libreact'
import type { JSX } from 'react'
import { Link } from 'wouter'
import { AssetSvg } from '../foundation/Svg'
import styles from './BackButton.scss'

export function BackButton({
	href,
	label,
	className,
	ref,
}: {
	href: string
	label?: string
	className?: string
	ref?: React.RefObject<HTMLButtonElement | null>
}): JSX.Element
export function BackButton({
	onClick,
	label,
	className,
	ref,
}: {
	onClick: () => void
	label?: string
	className?: string
	ref?: React.RefObject<HTMLButtonElement | null>
}): JSX.Element
export function BackButton({
	href,
	label,
	className,
	onClick,
	ref,
}: {
	href?: string
	label?: string
	className?: string
	onClick?: () => void
	ref?: React.RefObject<HTMLButtonElement | null>
}): JSX.Element {
	const translator = useTranslator()

	if (onClick) {
		return (
			<button
				ref={ref}
				type="button"
				tabIndex={0}
				onClick={onClick}
				onKeyDown={e => {
					if (e.key === ' ' || e.key === 'Return') onClick()
				}}
				role="link"
				className={classes(styles.container, className)}
				aria-label={translator.translate('aria:back-button')}
			>
				<AssetSvg
					name={'assets/BackArrow.svg'}
					className={styles.picto}
					aria-label="Icone retour"
				/>

				<span>{label}</span>
			</button>
		)
	}

	return (
		<Link
			href={href!}
			className={classes(styles.container, className)}
			aria-label={translator.translate('aria:back-button')}
		>
			<AssetSvg
				name={'assets/BackArrow.svg'}
				className={styles.picto}
				aria-label="Icone retour"
			/>
			{label}
		</Link>
	)
}
